<template>
  <div class="text-left">
    <div>
      <div class="caption blue-grey--text text--darken-1  mb-1">
        {{ $t('common.roles.owner') }}
      </div>
      <ChipAvatar small :account="challenge.createdBy" />
    </div>
    <div class="d-flex mt-2">
      <div class="mr-4">
        <div class="caption blue-grey--text text--darken-1  mb-1">
          {{ $t('common.date.start_date') }}
        </div>
        <div
          v-if="challenge.startAt"
          class="body-2 blue-grey--text text--darken-3"
        >
          {{ formatDate(challenge.startAt, 'MMM D, YY') }}
        </div>
        <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
      </div>
      <div class="mr-4">
        <div class="caption blue-grey--text text--darken-1  mb-1">
          {{ $t('common.date.end_date') }}
        </div>
        <div
          v-if="challenge.endAt"
          class="body-2 blue-grey--text text--darken-3"
        >
          {{ formatDate(challenge.endAt, 'MMM D, YY') }}
        </div>
        <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
      </div>
      <div>
        <div class="caption blue-grey--text text--darken-1  mb-1">
          {{ $t('common.number_of_revs') }}
        </div>
        <div
          v-if="challenge.totalRevs"
          class="body-2 blue-grey--text text--darken-3"
        >
          {{ challenge.totalRevs }}
        </div>
        <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
      </div>
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1 mb-1">
        {{ $t('challenge.description') }}
      </div>
      <div
        v-if="challenge.description"
        class="body-1 blue-grey--text text--darken-3"
      >
        {{ challenge.description }}
      </div>
      <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1  mb-1">
        {{ $t('challenge.kpi') }}
      </div>
      <div v-if="challenge.KPIs" class="body-1 blue-grey--text text--darken-3">
        {{ challenge.KPIs }}
      </div>
      <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1 mb-1">
        {{ $t('common.site_other') }}
      </div>
      <ChipList outlined :limit="5" :items="sites" />
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1 mb-1">
        {{ $t('common.category_other') }}
      </div>
      <ChipList outlined :limit="5" :items="categories" />
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1 mb-1">
        {{ $t('common.tag_other') }}
      </div>
      <ChipList outlined :limit="5" :items="tags" />
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1  mb-1">
        {{ $t('challenge.rewards') }}
      </div>
      <div
        v-if="challenge.rewardsText"
        class="body-1 blue-grey--text text--darken-3"
      >
        {{ challenge.rewardsText }}
      </div>
      <p v-else class="ma-0 pa-0 blue-grey--text text--darken-1">-</p>
    </div>
    <div class="mt-4">
      <div class="caption blue-grey--text text--darken-1 mb-1">
        {{ $t('common.creation_date') }}
      </div>
      <div class="body-2 blue-grey--text text--darken-3">
        {{ formatDate(challenge.createdAt, 'MMM D, YY') }}
      </div>
    </div>
  </div>
</template>

<script>
import { utils } from 'frontend-js-shared'

import ChipAvatar from '@/components/ChipAvatar.vue'
import ChipList from '@/components/ChipList.vue'
export default {
  name: 'ChallengeContent',

  components: {
    ChipAvatar,
    ChipList,
  },

  props: {
    challenge: { type: Object, required: true },
  },

  computed: {
    tags() {
      return this.challenge?.tags?.map(tag => tag.name) ?? []
    },

    categories() {
      return (
        this.challenge?.categories?.map(category =>
          this.$t(`common.categories.${category}`)
        ) ?? []
      )
    },

    sites() {
      return this.challenge?.site?.map(site => site.name)
    },
  },

  methods: {
    formatDate(date, format) {
      return utils.dates.formatDate(date, format)
    },
  },
}
</script>
